import React, { useState } from 'react';
import { Calendar } from 'react-date-range';
import { constructUTCDate, getISODateString } from '../../helpers/datetime';
import Button from '../Button/Button';
import { upload } from '../../services/upload';

import '../MetRateDownloadView/MetRateDownloadView.css';

export default function UploadView() {
  const [date, setDate] = useState((new Date()).toISOString());
  const [uploadedFile, setUploadedFile] = useState('');
  const [uploadedFilename, setUploadedFilename] = useState('');
  const [error, setError] = useState('');
  const [downloadLinks, setDownloadLinks] = useState({ uploadStatus: '' });

  const uploadObject = (event) => {
    const reader = new FileReader();
    const { target } = event || {};
    const { files } = target || {};
    const [file] = files || [];
    const { name } = file || {};
    reader.readAsDataURL(file);
    reader.onload = (uploadEvent) => {
      const { target: uploadedTarget } = uploadEvent || {};
      const { result } = uploadedTarget || {};
      setUploadedFile(result);
    };
    setUploadedFilename(name);
  };
  const uploadData = () => {
    setDownloadLinks({ uploadStatus: 'Uploading...' });
    upload({
      uploadedFile,
      uploadedFilename,
      date,
    })
      .then(setDownloadLinks)
      .catch((errorObject) => {
        const { message } = errorObject || {};
        setError(message);
      });
  };
  return (
    <div className="met-rate-download-view">
      <div>
        <Calendar
          onChange={(day) => setDate(getISODateString(day))}
          date={constructUTCDate(date)}
        />
        <label htmlFor="uploaded-file" className="upload-data">
          <div>Upload Data</div>
          <input onChange={uploadObject} id="uploaded-file" name="file" type="file" />
        </label>
        <Button onClick={uploadData} label="Upload" />
        {error ? <span>{error}</span> : null}
        {
          Object.keys(downloadLinks).sort().map((key) => (
            key === 'warning' || key === 'uploadStatus'
              ? <span>{downloadLinks[key]}</span>
              : <a href={downloadLinks[key]} className="button" key={downloadLinks[key]}>{key}</a>
          ))
        }
      </div>
    </div>
  );
}
